import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { pastEvents } from "../../../../actions/admin/scheduled-event-actions";
import isEmpty from "../../../../validation/is-empty";
import Loader from "../../../../components/Loader/Loader";
import PastViewDetails from "./past-view-details";
import { Pagination } from "antd";
import { Row, Col } from "reactstrap";
import PaginatorDropdown from "../../../../components/Datatable/PaginationDropdown";
import Filter from "../../../../components/Filter/Filter";
import { toggleFilter } from "../../../../actions/filterActions";
import PastFilters from "./past-filters";
import ScheduledEventCard from "./ScheduledEventCard";
import ScheduledDayGroup from "./ScheduledDayGroup";

class Past extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
      totalEvents: 0,
      bookingId: null,
      showViewDetailModal: false,
      isLoading: false,
      pageLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
      },
    };
  }

  onPageSizeChange = (e) => {
    this.setState({
      isLoading: true,
    });
    this.fetchListEvents({
      pagination: {
        current: 1,
        pageSize: e.target.value,
      },
    });
  };

  onPageChange = (page, pageSize) => {
    this.setState({
      isLoading: true,
    });
    this.fetchListEvents({
      pagination: {
        current: page,
        pageSize: pageSize,
      },
    });
  };

  prepareDataParam = (params) => {
    let sortField = "id";
    let sortOrder = "asc";

    if (!isEmpty(params.sortField) && !isEmpty(params.sortOrder)) {
      sortField = params.sortField;
      sortOrder = params.sortOrder === "ascend" ? "asc" : "desc";
    }

    return {
      pageSize: params.pagination.pageSize,
      pageNumber: params.pagination.current,
      sortField,
      sortOrder,
      filter: {
        ...params.filters,
      },
    };
  };

  fetchListEvents = (params = {}) => {
    const { pastEvents } = this.props || {};
    pastEvents({
      data: this.prepareDataParam(params),
      onSuccess: (response) => {
        const { data, total } = response;
        this.setState({
          events: data,
          totalEvents: total,
          isLoading: false,
          pageLoading: false,
          pagination: { ...params.pagination },
        });
      },
      onError: (error) => {
        console.error(error);
        this.setState({ isLoading: false });
      },
    });
  };

  componentDidMount() {
    const { pagination } = this.state;
    this.setState({
      isLoading: true,
    });
    this.fetchListEvents({ pagination });
  }

  onViewDetail = (bookingData) => {
    this.setState({
      bookingId: bookingData.id,
      showViewDetailModal: true,
    });
  };

  hideViewDetailModal = () => {
    this.setState({
      showViewDetailModal: false,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.fetchListEvents({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      filters,
    });
  };

  clearFilterHandler = () => {
    this.handleTableChange(
      {
        ...this.state.pagination,
      },
      {},
      {}
    );
  };

  filterRecords = () => {
    const { toggleFilter, filter } = this.props;
    toggleFilter(false);
    this.setState({
      isLoading: true,
    });
    this.handleTableChange(
      {
        current: 1,
        pageSize: this.state.pagination.pageSize,
      },
      {
        ...filter.searchFilters,
      },
      {}
    );
  };

  updatePastEventStatus = (id, status) => {
    const processedEvents = { ...this.state.events };
    Object.keys(processedEvents).forEach((key) => {
      (processedEvents[`${key}`] || []).forEach((event) => {
        if (event.id === id) {
          event.status = status;
        }
      });
    });
    this.setState({
      events: processedEvents,
    });
    this.hideViewDetailModal();
  };

  render() {
    const {
      events,
      isLoading,
      pagination,
      showViewDetailModal,
      bookingId,
    } = this.state || {};
    return (
      <div className="rd_pasevencontth">
        <Row>
          <Col sm="12">
            <Filter
              name="Past events"
              level="section"
              subtitle="Bookings that are already finished."
              onFilterRecords={this.filterRecords}
              onClearFilterHandler={this.clearFilterHandler}
            >
              <PastFilters />
            </Filter>
          </Col>
        </Row>

        <Loader isShowLoader={isLoading} />
        {showViewDetailModal && (
          <PastViewDetails
            bookingId={bookingId}
            showViewDetailModal={showViewDetailModal}
            handleClose={this.hideViewDetailModal}
            updatePastEventStatus={this.updatePastEventStatus}
          />
        )}
        {Object.keys(events).length > 0 ? (
          <Fragment>
            {Object.keys(events).map((key) => (
              <ScheduledDayGroup dateKey={key} key={key}>
                {(events[`${key}`] || []).map((event, innerIndex) => (
                  <ScheduledEventCard
                    key={event.id || innerIndex}
                    event={event}
                    onViewDetail={this.onViewDetail}
                  />
                ))}
              </ScheduledDayGroup>
            ))}
          </Fragment>
        ) : !isLoading ? (
          <div className="se-empty">
            <strong>No past events</strong>
            <span>Completed and cancelled bookings will show up here.</span>
          </div>
        ) : null}
        {Object.keys(events).length > 0 ? (
          <Row className="pb-4 pr-md-3 mt-3">
            <Col className="text-center" lg="12" md="12">
              <Pagination
                className="list-view-pagination"
                defaultCurrent={pagination.current}
                current={pagination.current}
                total={this.state.totalEvents}
                pageSize={pagination.pageSize}
                onChange={this.onPageChange}
                showSizeChanger={false}
              />
            </Col>
            <Col sm="6" className="table_paginaton">
              <PaginatorDropdown
                styleClasses={"mt-3"}
                onPageSizeChange={this.onPageSizeChange}
                pageSize={pagination.pageSize}
              />
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  filter: state.filter,
});

export default connect(mapStateToProps, {
  pastEvents,
  toggleFilter,
})(Past);
